export const SNACKBAR_FILE_REQUESTS_CONTAINER_ID = "snackbar-file-requests";
export const SNACKBAR_FILE_TRANSFERS_CONTAINER_ID = "snackbar-file-transfers";
